import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { env } from "@/lib/env";

function LegalPage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="mx-auto max-w-2xl space-y-6 px-6 py-12">
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" /> Back to home
      </Link>
      <h1 className="text-3xl font-bold">{title}</h1>
      <div className="space-y-4 text-sm leading-relaxed text-muted-foreground [&_h2]:pt-2 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-foreground">
        {children}
      </div>
    </main>
  );
}

/*
 * DRAFTS. Both pages must be completed (operator details) and reviewed before launch; they are
 * linked from the landing page footer and the Settings dialog.
 */

export function ImprintPage() {
  return (
    <LegalPage title="Imprint">
      <p>{env.appName} is operated by:</p>
      <p data-testid="imprint-operator">
        [Company or name]
        <br />
        [Street and number]
        <br />
        [Postcode, city, country]
        <br />
        Email: [contact address]
      </p>
    </LegalPage>
  );
}

export function PrivacyPage() {
  return (
    <LegalPage title="Privacy">
      <p>
        {env.appName} has no accounts and asks for nothing but a display name, which is visible to
        the other players in your room.
      </p>
      <h2>What we store</h2>
      <p>
        Rooms, display names, issues and votes are stored on our server (Fly.io, Frankfurt). Your
        browser keeps an anonymous guest session, your settings and, if you bought one, your license
        key in its local storage.
      </p>
      <h2>Analytics</h2>
      <p>Plausible Analytics counts page views without cookies and without personal data.</p>
      <h2>Advertising</h2>
      <p>
        Without a license, pages show ads from Google AdSense. Google may use cookies for this; in
        the EEA, the UK and Switzerland you are asked for consent first.
      </p>
      <h2>Payments</h2>
      <p>
        Licenses are sold by Polar (polar.sh), which processes the payment and your email address as
        merchant of record and emails you the license key. We only keep the key itself, hashed.
      </p>
    </LegalPage>
  );
}
